const contractType = Object.freeze({
  New: 1,
  Renewal: 2,
  Amendment: 3,
});

export default contractType;
